export const getDateFormat = (dateString: string) => {
  const d = new Date(dateString);

  // Extract components
  let day: string | number = d.getDate();
  let month: string | number = d.getMonth() + 1; // Months are 0-based
  const year: string | number = d.getFullYear();
  let hours = d.getHours();
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();

  // Pad with leading zeros
  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;
  const mins = minutes < 10 ? "0" + minutes : minutes;
  const secs = seconds < 10 ? "0" + seconds : seconds;

  // AM/PM formatting
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // hour '0' should be '12'
  const hrs = hours < 10 ? "0" + hours : hours;

  const formatted = `${day}/${month}/${year} ${hrs}:${mins}:${secs} ${ampm}`;
  return formatted;
};
